// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3H38H","selects":"Documents_selects__2_8DX"};